import React, { useContext } from 'react';
import { CheckboxProps } from '../../Checkbox/src/Checkbox';

interface CheckboxGroupStateProps {
  size?: CheckboxProps['size'];
}

export const CheckboxGroupContext =
  React.createContext<CheckboxGroupStateProps | null>(null);

export function useCheckboxGroupContext(): CheckboxGroupStateProps | null {
  const context = useContext(CheckboxGroupContext);
  return context || null;
}
